import { UIRouterProvider } from "@skailer-com/uikit";
import { ReactNode } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";

// Внутри роутера и на всех корнях рендера, включая тесты: без него ui-kit бросает исключение.
export const RouterAdapter = ({ children }: { children: ReactNode }) => {
  const navigate = useNavigate();
  const { pathname } = useLocation();

  return (
    <UIRouterProvider LinkComponent={Link} navigate={navigate} pathname={pathname}>
      {children}
    </UIRouterProvider>
  );
};
